<template>
  <div class="agreement" >
    <login-header v-bind="headerInfo"></login-header>
    <div class="article_box">
      <div class="title">
        <h5>企迈云商服务条款</h5>
        <p>发布日期：2017-06-08</p>
      </div>
      <div class="detail" v-html="msg">

      </div>

    </div>
    <login-footer :description="desc"></login-footer>

  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'
export default {
  name: 'agreement',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      loading: false,
      headerInfo: {
        type: '用户登录',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '',
      msg: ''
    }
  },
  methods: {
    _getAgreement() {
      var that = this
      QM.apinew({
        // url: '/user/registerAgreement',
        url: '/seller/account/register-agreement', // 新
        method: 'GET',
        success: function (xdata) {
          that.msg = xdata.data.agreement
        },
        error: function (xdata) {

        }
      })
    }
  },
  created() {
    this._getAgreement()
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.socialization = this.loginInfo.is_master
  }

}
</script>

<style scoped>

</style>